
import React from 'react';
import { useProductCategoriesWithSubs } from '@/hooks/useProductCategories';

// Define fallback categories structure
const fallbackCategories = [
  { 
    name: 'Animal Feed', 
    subcategories: ['Cattle', 'Sheep & Goat', 'Horse', 'Poultry', 'Pig', 'Pets', 'Game or Wildlife', 'General or Other']
  },
  { 
    name: 'Animal Health & Medications', 
    subcategories: ['Cattle', 'Sheep & Goat', 'Horse', 'Poultry', 'Pig', 'Pets', 'General'] 
  },
  { 
    name: 'Pet Supplies', 
    subcategories: ['Dog', 'Cat', 'Bird', 'Accessories'] 
  },
  { 
    name: 'Livestock Management', 
    subcategories: ['Identification', 'Handling', 'Feeding & Watering', 'Housing'] 
  },
  { 
    name: 'Horse Tack & Grooming', 
    subcategories: ['Tack', 'Grooming', 'Protective Gear'] 
  },
  { 
    name: 'Gardening & Crop Supplies', 
    subcategories: ['Seeds', 'Fertilizers', 'Pest & Weed Control', 'Tools', 'Irrigation'] 
  },
  { 
    name: 'Farm Hardware & Tools', 
    subcategories: ['Hand Tools', 'Power Tool Accessories', 'Fasteners & Fixings', 'Fencing & Gates', 'General Hardware'] 
  },
  { 
    name: 'Pest & Wildlife Control', 
    subcategories: ['Insect Control', 'Rodent Control', 'Snake & Mole Repellents'] 
  },
  { 
    name: 'Building & Maintenance', 
    subcategories: ['Paints & Coatings', 'Adhesives & Sealants', 'Cleaning & Solvents', 'Plumbing & Electrical'] 
  },
  { 
    name: 'Clothing & Protective Gear', 
    subcategories: ['Workwear', 'Footwear', 'Safety Gear'] 
  },
  { 
    name: 'Miscellaneous', 
    subcategories: ['General Supplies', 'Eggs & Produce', 'Transport'] 
  },
  { 
    name: 'Seasonal Specials', 
    subcategories: [] 
  },
];

export const useCategoryNavigation = () => {
  const { categories, isLoading, error } = useProductCategoriesWithSubs();

  // Add error handling and loading states
  if (isLoading) {
    return { navCategories: fallbackCategories, isLoading: true };
  }

  if (error || !categories || categories.length === 0) {
    console.warn('Categories failed to load, using fallback:', error);
    return { navCategories: fallbackCategories, isLoading: false };
  }

  // Convert database categories to the format expected by MobileMenu
  const navCategories = categories.map(category => ({
    name: category.name,
    subcategories: category.product_subcategories?.map(sub => sub.name) || []
  }));

  return { navCategories, isLoading: false };
};
